// My requests' Show filter (poc CT-006, architecture 7.13, module-10 Section 3): which group a report is
// in, from the row's own fields, and the URL search for each choice. Computed in the browser: GET
// /api/my-requests already returns every report, unpaged.
import { FINISHED_STAGES } from '@feedback/shared/constants/workflow';
import type { MyRequestRow } from '@feedback/shared/contracts/query';

export type RequestGroup = 'pending' | 'resolved';
/** The Show choices, in the order the page offers them. Pending is the default. */
export const SHOW_CHOICES = ['pending', 'resolved', 'all'] as const;
export type Show = (typeof SHOW_CHOICES)[number];
/** The `show` search param: Pending has none. */
export interface ShowSearch {
  show?: Exclude<Show, 'pending'>;
}

/**
 * Resolved: a finished stage (Done, Not actioned), or a report its reporter withdrew, whatever the stage
 * (`withdraw_report` leaves the ticket open while it has other reports). Pending: everything else, which is
 * Triage to Awaiting confirmation; a report with no ticket yet reads Triage.
 */
export function requestGroup(row: MyRequestRow): RequestGroup {
  return row.withdrawnAt !== null || FINISHED_STAGES.includes(row.stage.code) ? 'resolved' : 'pending';
}

/**
 * `validateSearch` for S14: a missing or unknown `show` is Pending. The key is always returned, undefined for
 * Pending: TanStack Router merges the raw search under the validated one, so an omitted key would keep a raw
 * `?show=bogus`.
 */
export function parseShowSearch(search: Record<string, unknown>): ShowSearch {
  return { show: search.show === 'resolved' || search.show === 'all' ? search.show : undefined };
}

export function showSearch(show: Show): ShowSearch {
  return show === 'pending' ? {} : { show };
}
